


































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteAtualizacaoDePdfStore from '@/components/Suporte/Store/SuporteAtualizacaoDePdfStore'

@Component

export default class ViewSuporteAtualizacaoDePDF extends Vue {
  loadAtualizarPDFs: boolean = false

  get getSuporteAtualizacaoDePdfStore() {
    return getModule(SuporteAtualizacaoDePdfStore, this.$store)
  }

  get ids() { return this.getSuporteAtualizacaoDePdfStore.solicitacoesIds }
  set ids(value: string) { this.getSuporteAtualizacaoDePdfStore.setSolicitacoesIds(value) }

  get loadingAtualizarPDFs() { return this.loadAtualizarPDFs }
  set loadingAtualizarPDFs(value: boolean) { this.loadAtualizarPDFs = value }

  async atualizarPDFs() {
    this.loadingAtualizarPDFs = true
    const request = await this.getSuporteAtualizacaoDePdfStore.atualizarPDFs()
    if (request.success) {
      this.getSuporteAtualizacaoDePdfStore.clearSolicitacoesIds()
      EventBus.$emit('setSnackbar', { show: true, text: 'Atualização realizada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingAtualizarPDFs = false
  }

  beforeDestroy() {
    this.getSuporteAtualizacaoDePdfStore.clearSolicitacoesIds()
  }
}
